<div class="form-card">
    <div class="col-md-12 mt-3">
        <div class="static-width-for-card width-100">

            <div class="flex flex-row justify-content-between">
                Leave Balance
                <app-fusion-button [buttonValue]="'Apply Leave'" [buttonType]="'btn btn-primary'" data-bs-toggle="modal"
                    data-bs-target="#apply-leave">
                </app-fusion-button>
            </div>
            <div class="d-flex overflow-auto">
                <!-- <div *ngIf="noOfCasualLeave > 0" class="col col-md-4 border-primary rounded-3 align">
                    <div class="row d-flex border-primary rounded-3 align-items-center leave-set-height">
                        <div class="col">
                           <b> Casual leave </b>
                        </div>
                        <div class="col border-primary rounded-3 leave-balance-margin">
                            <div class = "d-flex justify-content-center text-primary"><b>{{noOfCasualLeave}}</b></div>
                            <div class="balance-text">Leave balance</div>
                        </div>
                    </div>
                </div>
                <div *ngIf="noOfSickLeave > 0" class="col col-md-4 border-primary rounded-3 leave-margin">
                    <div class="row d-flex border-primary rounded-3 align-items-center leave-set-height">
                        <div class="col">
                           <b>Sick leave</b>
                        </div>
                        <div class="col border-primary rounded-3 leave-balance-margin">
                            <div class = "d-flex justify-content-center text-primary"><b>{{noOfSickLeave}}</b></div>
                            <div class="balance-text">Leave balance</div>
                        </div>
                    </div>
                </div>
                <div *ngIf="noOfEarnedLeave > 0" class="col border-primary rounded-3 leave-margin">
                    <div class="row d-flex border-primary rounded-3 align-items-center leave-set-height">
                        <div class="col">
                           <b> Earned leave </b>
                        </div>
                        <div class="col border-primary rounded-3 leave-balance-margin">
                            <div class = "d-flex justify-content-center text-primary"><b>{{noOfEarnedLeave}}</b></div>
                            <div class="balance-text">Leave balance</div>
                        </div>
                    </div>
                </div> -->
                <!-- SK19JUL24 display all allocated leave types -->
                <div *ngFor="let leave of templateGet" class="col border-primary rounded-3 leave-margin">
                    <div class="row d-flex border-primary rounded-3 align-items-center leave-set-height">
                        <div class="col">
                            <b>{{leave.leaveType}}</b>
                        </div>
                        <div class="col border-primary rounded-3 leave-balance-margin">
                            <div class="balance-text">Leave balance <p class="blue-text">{{leave.noOfDays}}</p>
                            </div>
                            <div class="balance-text">Initial Leave <p class="blue-text">{{ leave.initialLeave ?? 0 }}
                                </p>
                            </div> <!-- SKS16OCT24 -->
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <!-- to show leave history // SK17JAN24 reducing api call-->
            <app-Leave-history #leaveHistory (leavesEmitData)="getData()" [selectedEmployeeId]="this.employeeId"
                [employeeLeaves]="employeeLeaves"> </app-Leave-history>
            <!-- Apply leave modal -->
            <div #applyleave class="modal fade container-md" id="apply-leave"  tabindex="-1" aria-labelledby="applyLeaveLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-md">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="modal-title fs-5" id="applyLeaveLabel">Apply Leave</div>
                            <app-fusion-button [buttonType]="'btn-close'" [dataDismiss]="'modal'"
                                (buttonClickEmit)="resetForm()" [fcBtnId]="'close'"></app-fusion-button>

                        </div>
                        <form class="form flex flex-direction-column" [formGroup]="applyLeaveForm" autocomplete="off">
                            <div class="flex">
                                <div class="row g-3 flex w-100">
                                    <div class="field-input w-100"
                                        [class]=" applyLeaveForm.controls['leaveType'].invalid && applyLeaveForm.controls['leaveType'].touched ? 'has-error' : '' ">
                                        <!--RG26AUG24 added asterisk to important fields -->
                                        <label for="leave-type" class="modal-field-label">Leave Type*</label>
                                        <select id="leave-type" formControlName="leaveType" class="form-select"
                                            (change)="leaveCalc()">
                                            <option>Select</option>
                                            <option *ngFor="let data of templateGet; let i=index"
                                                value="{{data.leaveType}}">
                                                {{data.leaveType}}
                                            </option>
                                        </select>
                                        <div>
                                            <p class="error-msg"><span
                                                    *ngIf="this.applyLeaveForm.controls['leaveType'].invalid && this.applyLeaveForm.controls['leaveType'].touched">Select
                                                    Leave Type</span></p>
                                            <p class="msg-display"><span
                                                    *ngIf=" this.applyLeaveForm.value.leaveType != '' ">No.
                                                    of {{leaveType}} : {{availDays}}</span></p>
                                        </div>
                                    </div>
                                    <div class="field-input w-100"
                                        [class]=" applyLeaveForm.controls['startDate'].invalid && applyLeaveForm.controls['startDate'].touched  || startDayError ? 'has-error' : '' ">
                                        <label class="modal-field-label" for="start-date">Start Date*</label>
                                        <input type="date" max="9999-12-31" formControlName="startDate" id="start-date"
                                            name="startDate" format="mm-dd-yyyy" class="input-border"
                                            (change)="startDate($event); leaveCalc()" />
                                        <p class="error-msg"><span
                                                *ngIf="applyLeaveForm.controls['startDate'].invalid && applyLeaveForm.controls['startDate'].touched || startDayError">Select
                                                valid date
                                            </span></p>
                                    </div>
                                    <div class="field-input w-100"
                                        [style]="this.applyLeaveForm.value.startDate && this.applyLeaveForm.value.endDate ? 'display: block' : 'display:none' "
                                        [class]=" applyLeaveForm.controls['startDateSession'].invalid && applyLeaveForm.controls['startDateSession'].touched  || startSessionError ? 'has-error' : '' ">
                                        <label class="modal-field-label" for="start-date-session">Start Date
                                            Session</label>
                                        <select type="checkbox" name="startDateSession" id="start-date-session"
                                            formControlName="startDateSession" (change)="leaveCalc()"
                                            class="form-select">
                                            <option value="Full Day" selected>Full Day</option>
                                            <option *ngIf="endDate1 - startDate1 === 0" value="First Half">First Half
                                            </option>
                                            <option value="Second Half">Second Half</option>
                                        </select>
                                        <p class="error-msg mt-1"><span
                                                [style]="applyLeaveForm.controls['startDateSession'].invalid && applyLeaveForm.controls['startDateSession'].touched || startSessionError ? 'visibility: visible' : 'visibility:hidden' ">Session
                                                Error
                                            </span></p>
                                    </div>
                                    <div class="field-input w-100"
                                        [class]=" applyLeaveForm.controls['endDate'].invalid && applyLeaveForm.controls['endDate'].touched || leaveError ? 'has-error' : '' ">
                                        <label class="modal-field-label" for="end-date">End Date*</label>
                                        <input type="date" max="9999-12-31" formControlName="endDate" id="end-date"
                                            name="endDate" format="mm-dd-yyyy" class="input-border"
                                            (change)="endDate($event); leaveCalc()" />
                                        <p class="error-msg"><span
                                                *ngIf="applyLeaveForm.controls['endDate'].invalid && applyLeaveForm.controls['endDate'].touched || leaveError">
                                                {{leaveError === true ? 'Leave is not sufficient' : 'Select valid
                                                date'}}
                                            </span></p>
                                    </div>
                                    <div class="field-input w-100"
                                        [class]=" applyLeaveForm.controls['endDateSession'].invalid && applyLeaveForm.controls['endDateSession'].touched  ? 'has-error' : '' "
                                        *ngIf="endSession">
                                        <label class="modal-field-label" for="end-date-session">End Date Session</label>
                                        <select type="checkbox" name="endDateSession" id="end-date-session"
                                            formControlName="endDateSession" (change)="leaveCalc()" class="form-select"
                                            placeholder="Select">
                                            <option value="Full Day" selected>Full Day</option>
                                            <option value="First Half">First Half</option>
                                        </select>
                                    </div>
                                    <div class="field-input w-100 col-md-6"
                                        [class]=" applyLeaveForm.controls['reason'].invalid && applyLeaveForm.controls['reason'].touched ? 'has-error' : '' ">
                                        <label for="reason" class="modal-field-label">Reason*</label>
                                        <input type="text" formControlName="reason" id="reason"
                                            placeholder="Heavy fever since yesterday night. So need 1 day leave today"
                                            class="input-border">
                                        <p class="error-msg"><span
                                                *ngIf="applyLeaveForm.controls['reason'].invalid && applyLeaveForm.controls['reason'].touched">Enter
                                                the reason</span></p>
                                    </div>
                                    <div [class]="holidayDay ? 'error-msg' : 'msg-display' "><span
                                            [style]="showNoOfLeaves || holidayDay ? 'visibility: visible' : 'visibility: hidden' ">{{
                                            holidayDay ? 'The selected start
                                            date (or) end date is in week off / holiday lists' : 'No. of Days applied :
                                            ' + (leaveNum + absentCount)}}</span></div>
                                    <!-- SKS3DEC24 sandwichLeave date show div. if 'sandwichLeave' is enabled in settings data-->
                                    <div [class]="holidayDay ? 'error-msg' : 'msg-display' "
                                        style="word-wrap: break-word; white-space: normal;">
                                        <span
                                            [style]="showNoOfLeaves || holidayDay ? 'visibility: visible' : 'visibility: hidden' ">
                                            <p *ngFor="let group of notAbsentDates">
                                                <strong>Status:</strong> {{ group.status }}<br>
                                                <strong>Dates:</strong>
                                                <span *ngIf="group.dates && group.dates.length > 0">
                                                    <span *ngFor="let date of group.dates"
                                                        style="display: inline-block;">
                                                        {{ date }} ,
                                                    </span>
                                                </span>
                                            </p>
                                        </span>
                                    </div>
                                    <div class="flex justify-content-end" *ngIf="!showConfirmation">
                                        <app-fusion-button [buttonType]="'btn btn-secondary'" [dataDismiss]="'modal'"
                                            [buttonValue]="'Cancel'"
                                            (buttonClickEmit)="resetForm()"></app-fusion-button>
                                        <app-fusion-button [buttonType]="'btn btn-primary ms-2'" [buttonValue]="'Apply'"
                                            (buttonClickEmit)="applyLeaveData()"
                                            [buttonDisable]="!applyLeaveForm.valid || startSessionError || startDayError || leaveError || holidayDay || startendStatus || isPresent "></app-fusion-button>
                                    </div>
                                    <!-- SKS3DEC24 sandwichLeave conformation button-->
                                    <div [class]="'msg-display'" *ngIf="showConfirmation"><span
                                            [style]="'visibility: visible'">{{ sandwichMess.message }}</span></div>
                                    <div class="flex justify-content-end" *ngIf="showConfirmation">
                                        <app-fusion-button [buttonType]="'btn btn-secondary'" [dataDismiss]="'modal'"
                                            [buttonValue]="'Cancel'"
                                            (buttonClickEmit)="cancelLeave()"></app-fusion-button>
                                        <app-fusion-button [buttonType]="'btn btn-primary ms-2'"
                                            [buttonValue]="'Confirm'" [dataDismiss]="'modal'"
                                            (buttonClickEmit)="confirmLeave()"></app-fusion-button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>